<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Insurance Deductibles</h3>
        <div>
            <button class="primary-btn" style="min-width:100px;" [routerLink]="['/mem-insurance']">Add</button>
        </div>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form contracts-flex-form top-filter-panel">
                    <div class="form-group">
                        <label>Site</label>
                        <select [(ngModel)]="selectedCMSiteID" (change)="onChangeCMSite()" class="form-control" name="sites">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of sites" [value]="opt.siteID">
                                {{ opt.siteName }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Manager</label>
                        <select [(ngModel)]="selectedUserID" (change)="onChangeUserDD()" class="form-control" name="manager">
                            <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                {{ opt.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Protection Plain</label>
                        <select [(ngModel)]="protectionPlanID" (change)="onChangeProtectionPlan()" class="form-control" name="protectionplan">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of ref_MemProtectionPlan_List" [value]="opt.statusID">
                                {{ opt.status }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Protection Status</label>
                        <select [(ngModel)]="protectionStatusID" (change)="onChangeProtectionStatus()" class="form-control" name="protectionstatus">
                            <option value="0">--ALL--</option>
                            <option *ngFor="let opt of ref_MemProtectionStatus_List" [value]="opt.statusID">
                                {{ opt.status }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">Time Frame</label>
                        <div *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">
                            <select [(ngModel)]="selectedCtDtFilter" (change)="createDtFilterChange($event)" class="form-control" name="status">
                                <option *ngFor="let opt of createDateFilters" [value]="opt.value">
                                    {{ opt.name }}
                                </option>
                            </select>
                        </div>
                        <div class="custom-date" *ngIf="selectedCtDtFilter == 3 || selectedCtDtFilter == 4 || selectedCtDtFilter == 5 || selectedCtDtFilter == 6">
                            <label>Custom Range</label>
                            <div class="display-row">
                                <mat-form-field appearance="outline">
                                    <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange" readonly>
                                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle class="custom-daterange-toggle" matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                                    <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
                                    <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
                                </mat-form-field>
                                <i class="fa fa-undo" (click)="revertCustomFinalizeddtFilter()" style="font-size:20px; margin-left:10px;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Search</label>
                        <div class="button-group">
                            <input matInput class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-panel">
                <div class="table-body">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                            <ng-container>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                                <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
                                    <div class="customer-name" *ngIf="column.field == 'contactName'">
                                        <a href="javascript:void(0)" (click)="navToMemContact(dataItem?.contactID)">{{dataItem[column.field]}}</a>
                                    </div>
                                    <div class="customer-name" *ngIf="column.field == 'protectionPlan'">{{getProtectionDDName(dataItem[column.field])}}</div>
                                    <div class="customer-name" *ngIf="column.field == 'protectionStartDate'">{{ dataItem[column.field] | date:dateFormat  }}</div>
                                    <div class="customer-name" *ngIf="column.field == 'protectionDeductibleAmount'">{{ dataItem[column.field] }} </div>
                                    <div class="customer-name" *ngIf="column.field == 'lostEquipmentCreditTotal'">{{ dataItem[column.field]}} </div>
                                    <div class="customer-name" *ngIf="column.field == 'protectionEndDate'">{{ dataItem[column.field] | date:dateFormat }} </div>
                                    <div class="customer-name" *ngIf="column.field == 'protectionStatus'">{{getStatusDDName(dataItem[column.field])}} </div>
                                </td>
                            </ng-container>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="deductiblesListDisplayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: deductiblesListDisplayColumns;" (click)="selectRow(row)"
                            [class.selected]="selectedRow === row"></tr>
                    </table>
                    <mat-paginator *ngIf="deductibles?.length > 0" [pageSize]="50"
                                   [length]="deductibles?.length" [pageSizeOptions]="[10, 50, 100,200]"></mat-paginator>

                </div>
            </div>
        </div>
    </div>
</div>

